// customized modernizr build
require('./util/_modernizr');


// fastclick eliminates click delay in certain browsers
var fastclick = require('fastclick');
fastclick(document.body);

// svg polyfill for better xlink support
var svg4everybody = require('svg4everybody');
svg4everybody();

// global jquery
global.jQuery = require('jquery');

// flickity with imagesloaded
var Flickity = require('flickity');
require('flickity-imagesloaded');

// bridget turns flickity into a jquery plugin
require('jquery-bridget');
jQuery.bridget('flickity', Flickity);

// placeholder attribute polyfill
require('jquery-placeholder');
jQuery('input, textarea').placeholder();



// modules
require('./modules/_accordion');
require('./modules/_alert');
require('./modules/_filter');
require('./modules/_header');
require('./modules/_slideshow');
require('./modules/_subnav');
require('./modules/_tabs');
require('./modules/_testimonials');
require('./modules/_gallery');
require('./modules/_finder');
require('./modules/_dropdown');
require('./modules/_modal');
require('./modules/_print');
require('./modules/_form');
require('./modules/_directory');
